<section class="section section-shaped">
  <div class="container">
    <div class="row mb-3">
      @if (formType == FormType.Submission) {
        <div class="col-6">
          <div class="btn btn-primary-border float-right font-size-larger" (click)="print()">
            {{ 'common.print' | translate }} <i class="fa fa-print ml-3"></i>
          </div>
        </div>
      }
    </div>
    <div class="row justify-content-center mb-5 print-include">
      @if (applicationForm$) {
        <div class="col-lg-10">
          <app-dynamic-form
            [dynamicForm]="applicationForm$ | async"
            [submitText]="submitText | translate"
            (submitForm)="submit($event)"
            (subFormTriggered)="onSubFormTriggered($event)"
            [disableSubmit]="formType == FormType.Submission"
          >
          </app-dynamic-form>
          <div
            class="text-primary text-underline cursor-pointer back-button h5 tw-mt-5 tw-text-center"
            (click)="confirmBack()"
          >
            {{ 'common.back' | translate }}
          </div>
        </div>
      }
      @if (!applicationForm$) {
        <div class="col-lg-10">
          <agmo-loading></agmo-loading>
        </div>
      }
    </div>
  </div>
</section>
